export enum FrequencyType {
    Daily = 'D',
    Weekly = 'W',
    Monthly = 'M'
}

export enum TransferType {
    Email = 'E',
    FTP = 'F'
}
